import app from 'flarum/common/app';
export function canViewKnowledgeBase() {
  return !!app.forum.attribute('canViewKnowledgeBase');
}

/**
 * IDs of the tags an admin selected as knowledge base categories. Empty when
 * the actor may not view the knowledge base.
 */
export function knowledgeBaseTagIds() {
  return app.forum.attribute('knowledgeBaseTagIds') || [];
}

/**
 * Whether a tag is a knowledge base category, or a child of one.
 */
export function isKnowledgeBaseTag(tag) {
  const ids = knowledgeBaseTagIds();
  const parent = tag.parent();
  return ids.includes(tag.id()) || !!parent && ids.includes(parent.id());
}

/**
 * The knowledge base category an article belongs to, if it is an article.
 */
export function knowledgeBaseCategory(discussion) {
  const tags = (discussion.tags() || []).filter(tag => !!tag);
  const ids = knowledgeBaseTagIds();
  return tags.find(tag => ids.includes(tag.id()));
}
export function isKnowledgeBaseArticle(discussion) {
  return !!knowledgeBaseCategory(discussion);
}
flarum.reg.add('soup-97-support', 'common/utils/knowledgeBase', { canViewKnowledgeBase: canViewKnowledgeBase,knowledgeBaseTagIds: knowledgeBaseTagIds,isKnowledgeBaseTag: isKnowledgeBaseTag,knowledgeBaseCategory: knowledgeBaseCategory,isKnowledgeBaseArticle: isKnowledgeBaseArticle, });